//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { events, DirUtil } from "@nuskin/ns-util";
import { MarketHeaderService } from "@nuskin/ns-product";
import { NsIcon } from "@nuskin/design-components";
import { isNullOrEmpty } from "@nuskin/ns-common-lib";

import NsMinimalHeaderRegionSelector from "./MinimalHeader/NsMinimalHeaderRegionSelector.vue";
import NsMinimalHeaderProfileDropdownMobile from "./MinimalHeader/NsMinimalHeaderProfileDropdownMobile.vue";
import NsMinimalHeaderLogo from "./MinimalHeader/NsMinimalHeaderLogo.vue";
import NsMinimalHeaderMiniCart from "./MinimalHeader/NsMinimalHeaderMiniCart.vue";
import NsMinimalHeaderTopnav from "./MinimalHeader/NsMinimalHeaderTopnav.vue";
import NsMinimalDrawer from "./MinimalHeader/NsMinimalDrawer.vue";
import NsMinimalHeaderDrawer from "./MinimalHeader/NsMinimalHeaderDrawer.vue";
import NsMinimalHeaderProfileToggle from "./MinimalHeader/NsMinimalHeaderProfileToggle.vue";
import vueEventBus from "./EventBus";

const DESKTOP_MAX_MARKETING_LENGTH = 100;

export default {
  name: "NsMinimalHeader",
  components: {
    NsIcon,
    NsMinimalHeaderRegionSelector,
    NsMinimalHeaderProfileDropdownMobile,
    NsMinimalHeaderProfileToggle,
    NsMinimalHeaderLogo,
    NsMinimalHeaderMiniCart,
    NsMinimalHeaderTopnav,
    NsMinimalDrawer,
    NsMinimalHeaderDrawer
  },
  data() {
    return {
      logoData: {},
      marketData: {},
      miniCartData: {},
      mobileDrawerOpen: false,
      profileData: {},
      searchResultsPageData: {},
      searchbarData: {},
      showMobileMarketingMessage: true,
      showSearchResults: false
    };
  },
  computed: {
    desktop() {
      return this.$mq === "desktop" || this.$mq === "desktopHD";
    },
    desktopOrTablet() {
      return this.desktop || this.$mq === "tablet";
    },
    market() {
      return (
        this.$NsAppService.runConfig.market ||
        this.$NsAppService.runConfig.country ||
        ""
      );
    },
    language() {
      return this.$NsAppService.runConfig.language || "";
    },
    locale() {
      return this.$NsAppService.locale || "";
    },
    baseUrl() {
      return this.$NsAppService.runConfig.baseUrl || "";
    },
    isStorefront() {
      return !!this.$NsAppService.isStorefront;
    },
    profileToggleTranslations() {
      if (this.profileData && this.profileData.translations) {
        return {
          greeting: this.profileData.translations.greeting,
          signInLabel: (this.profileData.translations.signIn || {}).name,
          signUpLabel: this.profileData.translations.signUp,
          signOutLabel: (this.profileData.translations.signOut || {}).name
        };
      }
      return {};
    },
    headerDrawerTranslations() {
      return {
        ...this.translations,
        ...this.profileToggleTranslations
      };
    },
    header() {
      return {
        //The URL for a distributor profile image that is shown in place of the NS Logo
        distributorImage:
          this.logoData.distributorImage ||
          this.marketData.distributorImage ||
          "",
        homeUrl: this.logoData.linkUrl || this.marketData.hrefOverride || "",
        id: this.marketData.id || "ns-header",
        joinUs: this.marketData.joinUs || {
          label: "Join",
          link: "/join.html"
        },
        accessibilityLink: this.marketData.accessibility || {
          showAccessibilityLink: false,
          accessibilityActivate: "Activate Accessibility",
          accessibilityDeactivate: "Turn Off Accessibility",
          accessibilityHref: "#",
          accessibilityStyle: "UsableNetAssistive",
          accessibilityOnclick: "return enableUsableNetAssistive()"
        },
        legalLinks: this.marketData.legalLinks || [],
        marketingMessage: this.marketData.marketingMessage || {
          info: "",
          href: "",
          link: ""
        },
        region: this.marketData.region || {},
        regionSelectorPath:
          this.marketData.regionSelectorPath ||
          "/content/nuskin.html#region-selection",
        translations: this.marketData.translations || {
          selectOther: "Select Other"
        },
        cartText: this.miniCartData.shoppingBagText || "",
        showCartText: this.miniCartData.showShoppingBagText || false,
        // profile
        profileMenu: this.profileData.profileMenu || [],
        signOutUrl: (() => {
          const translations = this.profileData.translations || {};
          return (translations.signOut && translations.signOut.href) || "";
        })(),
        signUpUrl: this.profileData.signUpUrl || "",
        profileUrl:
          (this.profileData.profileMenu &&
            this.profileData.profileMenu[0].href) ||
          "",
        // storefront
        showDistributorImage:
          this.logoData.showDistributorImage ||
          this.marketData.showDistributorImage ||
          false
      };
    },
    dir() {
      return DirUtil.getDir();
    },
    utilityBarCenterClass() {
      const { info = "", link = "" } = this.header.marketingMessage || {};

      if (this.header.marketingMessage) {
        return info.length + link.length > DESKTOP_MAX_MARKETING_LENGTH
          ? "unlock-center"
          : "";
      } else {
        return "";
      }
    }
  },
  async mounted() {
    this.addListeners();
    this.getPropsFromAjax();
  },
  destroyed() {
    this.removeListeners();
  },
  methods: {
    closeMarketingMessage() {
      this.showMobileMarketingMessage = false;
    },

    async getPropsFromAjax() {
      let page = window.location.pathname.replace("#/", "");
      if (!page.includes(this.locale)) {
        page = "/content/";
        if (this.market.toLowerCase() === "jp") {
          page += "markets";
        } else {
          page += "nuskin";
        }
        page += `/${this.locale}/home.html`;
      } else {
        // Make sure JP is using content/markets path and not just /markets
        page =
          page.indexOf("content/markets/") > -1
            ? page
            : page.replace("/markets/", "/content/markets/");
      }

      const siteUrl = window.location.origin.startsWith("http://localhost")
        ? this.baseUrl || "https://test.nuskin.com"
        : window.location.origin;

      const headerData = await MarketHeaderService.getMarketHeaderData(
        page,
        siteUrl,
        false
      );

      if (isNullOrEmpty(this.logoData)) {
        this.logoData = headerData.logo || {};
      }

      this.marketData = headerData.market || {};
      this.miniCartData = headerData.miniCart || {};
      this.profileData = headerData.profile || {};
      this.searchResultsPageData = headerData.searchResultsPage || {};
      this.searchbarData = headerData.searchbar || {};
    },

    getOffSetHeight() {
      const domHeader = document.querySelector("#" + this.header.id);
      return domHeader ? domHeader.offsetHeight : 0;
    },

    /**
     * Subscribe to events, should only be called when mounted
     */
    addListeners() {
      window.addEventListener("resize", this.handleWindowResize);

      this.$watch(
        function() {
          return !this.$NsAppService.loading;
        },
        this.getPropsFromAjax,
        {
          immediate: true
        }
      );

      events.subscribe(
        events.global.RUN_CONFIG_CHANGED,
        this.$NsAppService.checkConfig
      );

      vueEventBus.$on("config-changed", this.handleConfigChanged);
    },

    /**
     * Unsubscribe from events, should only be called when destroyed
     */
    removeListeners() {
      window.removeEventListener("resize", this.handleWindowResize);

      events.unsubscribe(
        events.global.RUN_CONFIG_CHANGED,
        this.$NsAppService.checkConfig
      );

      vueEventBus.$off();
    },
    toggleMenu() {
      this.mobileDrawerOpen = !this.mobileDrawerOpen;
      events.publish("toggleDrawer");
    },

    handleConfigChanged() {
      this.getPropsFromAjax();
    },

    handleWindowResize() {
      setTimeout(() => {
        let offsetHeight = this.getOffSetHeight();
        document.documentElement.style.setProperty(
          "--header-height",
          `${offsetHeight}px`
        );
      }, 1);
    }
  }
};
